export default __webpack_public_path__ + "static/media/mobisis-logo-vector.936d9000.png";